<div class="row align-items-center p-b-10">
  <div class="col-sm-12 col-lg-7">



    <div class="d-flex align-items-center flexmob">

      <!-- <div class="d-flex align-items-center f-s-14 text-black-25 m-l-10 border-right p-x-10 cursor-pointer f-w-600" [routerLink]="['/charity']">-->
      <div class="d-flex align-items-center f-s-14 text-black-25 border-right p-r-10 cursor-pointer f-w-600" (click)="backToCharityOverView()">
        <!--<i-tabler class="icon-20 m-r-4 m-t-0 anim" name="arrow-left"></i-tabler> Back to Charity Overview-->
        <i-tabler class="icon-20 m-r-4 m-t-0" name="arrow-left"></i-tabler> Back to Charity Overview
      </div>
      <div class="m-l-10 d-flex">
        <!--<div>
          <button mat-fab style="width: 50px;height: 50px;border-radius: 20%;" class="brandbglight">
            <i-tabler name="scale" class="icon-28" style="line-height: 30px !important"></i-tabler>
          </button>
        </div>-->
        <div class="m-l-10">
          <h4 class="headingmain f-s-20 f-w-800 m-t-0 m-r-10">
            Trial Balance
          </h4>
          <h5 class="f-s-14  text-black-25 m-t-5 ">
            {{Basicinfodata[0]?.financial_Year}}
          </h5>
        </div>
      </div>
    </div>
  </div>

  <div class="col-sm-12 col-lg-5">
    <!--<div class="d-flex flex-sm-row flex-col align-items-center justify-content-end gap-10 flex-wrap">-->
    <div class="d-flex justify-content-end">
      <div class="p-8" style="background-color: #fff; border-radius:10px;">
        <button mat-flat-button class="bg-none import m-r-10" (click)="modalImport(importTrial)" [disabled]="!UserRoleAccess?.m1Import||apFinalised">
          <!--   <button mat-flat-button color="primary" (click)="modalImport(importTrial)" [disabled]="!UserRoleAccess?.m1Edit">-->

          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="download"></i-tabler> Import <!--Trial Balance-->
          </div>
        </button>
        <button *ngIf="Showpreview" mat-flat-button color="primary" class="bg-none m-r-10 p-x-10" [ngClass]="(!UserRoleAccess?.m1ExportorDownload) ? 'btn-disabled-cls' : '' " (click)="Preview(modal)" [disabled]="!UserRoleAccess?.m1ExportorDownload||disablePreview">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-10" name="eye"></i-tabler>Preview
          </div>
        </button>
        <button class="bg-none" *ngIf="Showpreview" mat-flat-button title="Send Mail" (click)="sendMailTemplate(emailtemplate)" [disabled]="!UserRoleAccess?.m1SendMail">
          <div class="d-flex align-items-center">
            <i-tabler class="icon-18 m-r-0" name="mail"></i-tabler>
          </div>
        </button>
      </div>
    </div>
  </div>

</div>

<!--Period Finalised & Ready to Submit-->
<ng-template #otherUI>
  <div *ngIf="apFinalised " class="col-md-12 col-lg-12 m-t-10 p-0">
    <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #fed7aa !important; background: #fff7ed; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
      <mat-card-content class="p-y-20">
        <div class="row align-items-center">
          <div class="col-md-8">
            <div class="d-flex align-items-center">
              <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #ff9f1f; background: #ffedd5; display: flex; align-items: center; justify-content: center;" class="text-warning">
                <i-tabler name="lock" class="icon-24" style="color: #ea580c;"></i-tabler>
              </div>
              <!--<div>
              <h4>Period Finalised & Ready to Submit</h4>
              <p class="m-y-2">Accounts have been finalised and are now ready to submit</p>
              </div>-->
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                  Period Finalised & Ready to Submit
                </h4>
                <div>
                  <h5 class="f-s-14 f-w-600 m-x-4">Accounts have been finalised and are now ready to submit  </h5>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 text-right lockUnlockRes">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <button mat-flat-button class="rounded-5" style="border: 1px solid #fdba74; background:#fff;" (click)="UnfreezeAP()">
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0" name="lock-open" style="color: #c2410c;"></i-tabler><span class="f-s-14" style="color: #c2410c;">Unlock</span>
                </div>
              </button>
              <button mat-flat-button color="primary" class="bg-success rounded-5" (click)="gotoSubmissions()">
                <div class="d-flex text-black">
                  <!--<i-tabler class="icon-20 m-r-4 m-t-0 text-white" name="arrow-right"></i-tabler>--><span class="f-s-14 text-white">Submit</span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</ng-template>
<!--Period Finalised & Ready to Submit ends-->
<!--Period Submitted-->
<div *ngIf="apFinalised &&  this.UserRoleAccess?.currentAPSubmitStatus != 'Not Submit' && this.UserRoleAccess?.currentAPSubmitStatus  !== 'Failed' ; else otherUI" class="col-md-12 col-lg-12 p-0">
  <mat-card class="cardWithShadow  shadow-none" style="border: 1px solid #A7F3D0 !important; background: #ECFDF5; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1) !important;">
    <mat-card-content class="p-y-20">
      <div class="row align-items-center">
        <div class="col-md-8">
          <div class="d-flex align-items-center">
            <div style="width: 50px; height: 50px; border-radius: 50%; border: 1px solid #9ee9c2; background: #d1fae5; display: flex; align-items: center; justify-content: center; " class="text-warning">
              <i-tabler name="circle-check" class="icon-30" style="color: #059669;"></i-tabler>
            </div>
            <div class="m-l-10">
              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-x-4">

                Period Submitted
              </h4>
              <div>
                <h5 class="f-s-14 f-w-600 m-x-4">Submitted to Companies House on {{this.UserRoleAccess?.currentAPSubmitDate}}</h5>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 text-right lockUnlockRes">
          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
            <button mat-flat-button color="primary" class="rounded-5 successBtn" (click)="UnlockandAmend()">
              <div class="d-flex">
                <i-tabler class="icon-20 m-r-4 m-t-0" name="reload"></i-tabler><span class="f-s-14">Unlock & Amend Accounts</span>
              </div>
            </button>
          </div>
        </div>
      </div>

    </mat-card-content>
  </mat-card>
</div>
<!--Ends Period Submitted-->

<fieldset [disabled]="apFinalised" class="p-0">
  <div class="spinner-container" *ngIf="ShowSpinner">
    <mat-spinner></mat-spinner>
  </div>

  <!--Start - below code is hidden-->
  <div class="row m-t-20 d-none">
    <div class="col-lg-3">
      <mat-card class="m-t-20">
        <mat-card-content class="bg-white border-radius10 p-16">
          <h5 class="f-s-14 f-w-600">Total Debits (Current Period):</h5>
          <p class="brandtext f-w-600 f-s-18"> {{TotalDebits | number:'1.2-2'}}</p>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-3">
      <mat-card class="m-t-20">
        <mat-card-content class="bg-white border-radius10 p-16">
          <h5 class="f-s-14 f-w-600">Total Credits (Current Period): </h5>
          <p class="brandtext f-w-600 f-s-18"> {{TotalCredits | number:'1.2-2'}}</p>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-3">
      <mat-card class="m-t-20">
        <mat-card-content class="bg-white border-radius10 p-16">
          <h5 class="f-s-14 f-w-600">Difference: </h5>
          <p *ngIf="TotalDebits!=TotalCredits" class="text-danger brandtext f-w-600 f-s-18"> {{Difference | number:'1.2-2'}}</p>
          <p *ngIf="TotalDebits==TotalCredits" class="text-success brandtext f-w-600 f-s-18"> {{Difference | number:'1.2-2'}}</p>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="col-lg-3">
      <mat-card class="m-t-20">
        <mat-card-content class="bg-white border-radius10 d-flex justify-content-center align-items-center p-16" style="height: 90px;">
          <h5 *ngIf="TotalDebits==TotalCredits" class="text-success f-s-16 f-w-600">Trial Balance is balanced </h5>
          <h5 *ngIf="TotalDebits!=TotalCredits" class="text-danger f-s-16 f-w-600">Trial Balance is unbalanced </h5>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <mat-card class="m-t-20 d-none">
    <mat-card-content class="bg-light-primary border-radius10 p-16">
      <div class="d-flex justify-content-between">
        <div>
          <span>Total Debits (Current Period):<span class="brandtext f-w-600 f-s-16"> {{TotalDebits | number:'1.2-2'}}</span></span> <span class="m-t-10 d-block">Total Credits (Current Period): <span class="brandtext f-w-600 f-s-16"> {{TotalDebits | number:'1.2-2'}}</span></span>
        </div>
        <div *ngIf="TotalDebits!=TotalCredits" class="text-danger"> <span>Difference: <span class="brandtext f-w-600 f-s-16"> {{Difference | number:'1.2-2'}}</span></span> <span class="m-t-10 d-block brand f-w-700">Trial  Balance is Unbalanced</span> </div>
        <div *ngIf="TotalDebits==TotalCredits" class="text-success"> <span>Difference: <span class="brandtext f-w-600 f-s-16"> {{Difference | number:'1.2-2'}}</span></span> <span class="m-t-10 d-block brand f-w-700">Trial  Balance is Unbalanced</span> </div>
      </div>
    </mat-card-content>
  </mat-card>
  <!--End - below code is hidden-->
  @if(this.isFundTracking){<!-- for grid of With fund tracking-->
  <div class="col-12 p-x-0">
    <mat-card style="margin-bottom:0px !important;">
      <mat-card-content class="p-y-16 p-x-0" style="background: #ffffff; border-radius: 5px; border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
        <div class="row p-x-16 align-items-center">
          <div class="col-lg-3 col-md-3">
            <div class="m-l-10 d-flex align-items-center">
              <div *ngIf="( (getAbsoluteDifference(TotalUnrestrictedCredit,TotalUnrestrictedDebit)==0) && (getAbsoluteDifference(TotalRestrictedDebit,TotalRestrictedCredit)==0) && (getAbsoluteDifference(TotalEndowmentDebit,TotalEndowmentCredit)==0) )">
                <div style="padding: 10px 0px; border-radius: 20%;" class="bg-light-successa">
                  <i-tabler name="circle-check" class="icon-28 text-success"></i-tabler>
                </div>
              </div>
              <div *ngIf="((getAbsoluteDifference(TotalUnrestrictedCredit,TotalUnrestrictedDebit)!=0) || (getAbsoluteDifference(TotalRestrictedDebit,TotalRestrictedCredit)!=0) || (getAbsoluteDifference(TotalEndowmentDebit,TotalEndowmentCredit)!=0) )">
                <div style="padding: 10px 0px; border-radius: 20%;" class="bg-light-errora">
                  <i-tabler name="alert-circle" class="icon-28 text-danger"></i-tabler>
                </div>
              </div>
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-r-10">
                  Balance Status
                </h4>

                <h5 *ngIf="( (getAbsoluteDifference(TotalUnrestrictedCredit,TotalUnrestrictedDebit)==0) && (getAbsoluteDifference(TotalRestrictedDebit,TotalRestrictedCredit)==0) && (getAbsoluteDifference(TotalEndowmentDebit,TotalEndowmentCredit)==0) )" class="text-success f-s-14 f-w-600">Trial Balance is balanced </h5>
                <h5 *ngIf="( (getAbsoluteDifference(TotalUnrestrictedCredit,TotalUnrestrictedDebit)!=0) || (getAbsoluteDifference(TotalRestrictedDebit,TotalRestrictedCredit)!=0) || (getAbsoluteDifference(TotalEndowmentDebit,TotalEndowmentCredit)!=0) )" class="text-danger f-s-14 f-w-600">Trial Balance is unbalanced </h5>

              </div>
            </div>
          </div>
          <div class="col-lg-9 col-md-9 text-right">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial bsDifference">
              <mat-card class="m-0" style="margin-bottom: 0px !important; border: 0px;">
                <mat-card-content class="card-diff brandbglight p-16" style="border-radius: 10px; background: #107e760a !important; ">
                  <!--<h5 class="primary-color-dark f-s-14 f-w-600">Unrestricted Difference:</h5>-->
                  <h5 class="f-s-14 f-w-600">Unrestricted Difference:</h5>
                  <p *ngIf="TotalUnrestrictedCredit!=TotalUnrestrictedDebit" class="text-danger brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(TotalUnrestrictedCredit,TotalUnrestrictedDebit))| number:'1.2-2'}}</p>
                  <p *ngIf="TotalUnrestrictedCredit==TotalUnrestrictedDebit" class="text-success brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(TotalUnrestrictedCredit,TotalUnrestrictedDebit))| number:'1.2-2'}}</p>
                </mat-card-content>
              </mat-card>
              <mat-card class="m-0" style="margin-bottom: 0px !important; border: 0px;">
                <mat-card-content class="card-diff brandbglight p-16" style="border-radius: 10px; background: #107e760a !important; ">
                  <!--<h5 class="primary-color-dark f-s-14 f-w-600">Restricted Difference: </h5>-->
                  <h5 class="f-s-14 f-w-600">Restricted Difference: </h5>
                  <p *ngIf="TotalRestrictedDebit!=TotalRestrictedCredit" class="text-danger brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(TotalRestrictedDebit,TotalRestrictedCredit))| number:'1.2-2'}}</p>
                  <p *ngIf="TotalRestrictedDebit==TotalRestrictedCredit" class="text-success brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(TotalRestrictedDebit,TotalRestrictedCredit))| number:'1.2-2'}}</p>
                </mat-card-content>
              </mat-card>
              <mat-card class="m-0" style="margin-bottom: 0px !important; border: 0px;">
                <mat-card-content class="card-diff brandbglight p-16" style="border-radius: 10px; background: #107e760a !important; ">
                  <!--<h5 class="primary-color-dark f-s-14 f-w-600">Endowment Difference: </h5>-->
                  <h5 class="f-s-14 f-w-600">Endowment Difference: </h5>
                  <p *ngIf="TotalEndowmentDebit!=TotalEndowmentCredit" class="text-danger brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(TotalEndowmentDebit,TotalEndowmentCredit))| number:'1.2-2'}}</p>
                  <p *ngIf="TotalEndowmentDebit==TotalEndowmentCredit" class="text-success brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(TotalEndowmentDebit,TotalEndowmentCredit))| number:'1.2-2'}}</p>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  }
  @else{<!-- for grid of With out fund  tracking-->

  <div class="col-12 p-x-0">
    <mat-card style="margin-bottom: 0px !important;">
      <mat-card-content class="p-y-16 p-x-0" style="background: #ffffff; border-radius: 5px; border: 1px solid #c1d6e7;">
        <div class="row p-x-16 align-items-center">
          <div class="col-lg-3">
            <div class="m-l-10 d-flex align-items-center">
              <div *ngIf="(TotalcurrentPeriodCredit==TotalcurrentPeriodDebit)">
                <div style="padding: 10px 0px; border-radius: 20%;" class="bg-light-successa">
                  <i-tabler name="circle-check" class="icon-28 text-success"></i-tabler>
                </div>
              </div>
              <div *ngIf="(TotalcurrentPeriodCredit!=TotalcurrentPeriodDebit)">
                <div style="padding: 10px 0px; border-radius: 20%;" class="bg-light-errora">
                  <i-tabler name="alert-circle" class="icon-28 text-danger"></i-tabler>
                </div>
              </div>
              <div class="m-l-10">
                <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-r-10">
                  Balance Status
                </h4>
                <h5 *ngIf="(TotalcurrentPeriodCredit==TotalcurrentPeriodDebit)" class="text-success f-s-14 f-w-600">Trial Balance is balanced </h5>
                <h5 *ngIf="(TotalcurrentPeriodCredit!=TotalcurrentPeriodDebit)" class="text-danger f-s-14 f-w-600">Trial Balance is unbalanced </h5>
              </div>
            </div>
          </div>
          <div class="col-lg-9 text-right">
            <div class="d-flex gap-10 justify-content-end custom-cards-trial">
              <mat-card class="m-0" style="margin-bottom: 0px !important; border: 0px;">
                <mat-card-content class="card-diff brandbglight p-16 p-x-32" style="border-radius: 10px; background: #107e760a !important; ">
                  <h5 class="primary-color-dark f-s-14 f-w-600">Difference: </h5>
                  <p *ngIf="TotalcurrentPeriodCredit!=TotalcurrentPeriodDebit" class="text-danger brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(TotalcurrentPeriodCredit,TotalcurrentPeriodDebit))| number:'1.2-2'}}</p>
                  <p *ngIf="TotalcurrentPeriodCredit==TotalcurrentPeriodDebit" class="text-success brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(TotalcurrentPeriodCredit,TotalcurrentPeriodDebit))| number:'1.2-2'}}</p>
                </mat-card-content>
              </mat-card>
            </div>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
  }
</fieldset>
<!--<div class="col-md-3 col-sm-12">
  <div class="" style="border-radius: 4px 0px 0px 0px;">
    <mat-form-field appearance="outline" class="hide-hint bg-white" style="border-radius: 10px; width:100%">
      <input matInput type="search" placeholder="Search" appInputRestriction='Trim'/>
      <mat-icon matSuffix>
        <i-tabler name="search" class="icon-20 m-0" style="line-height: 15px !important"></i-tabler>
      </mat-icon>
    </mat-form-field>
  </div>
</div>-->
<div class="col-12 p-10 p-x-2 m-t-4">

  <!--<mat-card class="m-t-14 b-0">-->
  <mat-card class="m-t-4 b-0">
    <!--<mat-card-content class="p-0">-->
    <mat-card-content class="p-0" style="padding:0px !important;">

      <div class="table-responsive shadow-lg rounded-3 mx-2 my-2" style="border: 1px solid #10727985 !important; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
        @if(this.isFundTracking){<!-- for grid of With fund tracking-->
        <table class="data-table">
          <!-- Header row for column names -->
          <thead style="position: sticky; top: 0px; z-index: 999;">
            <tr>
              <!-- <th class="f-s-14 f-w-500" colspan="2"> Particulars/Description <input [(ngModel)]="searchTerm" type="text" (input)="searchAccounts($event.target.value)" /></th>-->
              <th class="f-s-14 f-w-500" colspan="2"> Particulars/Description</th>
              <th class="f-s-14 f-w-500 text-center" colspan="6"> Current Period </th>
              <th class="f-s-14 f-w-500 text-center" *ngIf="this.Basicinfodata[0]?.withPrevoiusPeriod" colspan="2"> Previous Period </th>
            </tr>
            <tr>
              <th class="expand-column" colspan="2" style="width:14%;">
                <div class="" style="border-radius: 4px 0px 0px 0px;">
                  <mat-form-field appearance="outline" class="hide-hint bg-white" style="border-radius: 10px; width:100%">
                    <input matInput type="search" placeholder="Search" appInputRestriction='Trim' style="direction: ltr; text-align: left;" [(ngModel)]="searchTerm" (input)="searchAccounts($event.target.value)" />
                    <mat-icon matSuffix>
                      <i-tabler name="search" class="icon-20 m-0" style="line-height: 15px !important"></i-tabler>
                    </mat-icon>
                  </mat-form-field>
                </div>
              </th>
              <th *ngFor="let column of displayedColumnsUpdatedTrial" class="f-s-14 f-w-500 text-right"> {{ getColumnDisplayName(column) }} </th>
            </tr>
          </thead>
          <!-- Body with grouped data -->
          <tbody style="border: 1px solid #ebebeb; max-height: 560px; overflow-y: auto;">
            <ng-container *ngFor="let group of groupedData; let i = index">
              <!-- Header row (expandable) -->
              <!-- <tr [ngClass]="group.cursorpoint == false  ? 'header-row no-cursor' : 'header-row'" (click)="toggleGroup(i)">-->
              @if(group.showHeaer==true){
              <tr class="header-row" (click)="toggleGroup(i)">
                <td class="expand-column">
                  <mat-icon class="f-s-18 f-w-500" style="padding-top:3px !important;">{{ group.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                </td>
                <td colspan="10" class="header-cell f-s-14 f-w-600">{{ group.header.text }}</td>
              </tr>
              }

              <!-- Data rows (collapsible) -->
              <ng-container *ngIf="group.expanded">
                <tr *ngFor="let element of group.data" class="data-row">
                  @if(element.display==true){
                  @if(element.dataType=='Subheader'){
                  <td class="expand-column" style="background: #e7f3f2;"></td>
                  <td colspan="10" style="width: 450px !important; text-wrap: auto; background: #e7f3f2;" class="f-w-500 f-s-14">{{ element.accountName }}</td>
                  }
                  @if(element.dataType=='Subheader1'){
                  <td class="expand-column" style="background: #efefef;"></td>
                  <td colspan="10" style="width: 450px !important; background: #efefef; text-wrap: auto;" class="f-w-500 f-s-14 p-l-14">{{ element.accountName }}</td>
                  }
                  @else if(element.dataType=='Data'||element.dataType=='footer'){
                  <td class="expand-column"></td>
                  <td style="text-wrap: auto;">{{ element.accountName }}</td>
                  <td class="w130">
                    <mat-form-field appearance="outline" class="w-100" color="primary">


                      <input matInput
                             type="text"
                             appTwoDigitDecimalNumber
                             [(ngModel)]="element.unrestrictedDebit" (input)="MarkDirty()"
                             [ngClass]="element.nature == 'Debit' || element.nature == 'debit' || element.nature.toLowerCase() == 'nutral' ? 'text-success' : 'text-danger'"
                             (change)="CurrentPeriod_Calculation_FT($event, element.headersID, element.trailBalanceID, 'Debit', element.accountCode, 'Unrestricted', element.uniqueAccountsID)"
                             placeholder="0.00"
                             class="text-end"
                             [disabled]="apFinalised" />

                    </mat-form-field>
                  </td>
                  <td class="w130">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <!--<input matInput type="text" appTwoDigitDecimalNumber [value]="element.unrestrictedCredit==''?null:element.unrestrictedCredit"
                      [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Unrestricted',element.uniqueAccountsID)" placeholder="123" class="text-end" />-->
                      <input matInput [disabled]="apFinalised" type="text" appTwoDigitDecimalNumber [(ngModel)]="element.unrestrictedCredit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Unrestricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                    </mat-form-field>
                  </td>
                  <td class="w130">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input [disabled]="apFinalised" matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.restrictedDebit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Debit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Debit',element.accountCode,'Restricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                      <!--<input matInput type="text" appInputRestriction='decimalOnly' [value]="element.restrictedDebit==''?null:element.restrictedDebit" maxlength="8"
                      [ngClass]="element.nature=='Debit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Debit',element.accountCode,'Restricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                    </mat-form-field>
                  </td>
                  <td class="w130">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input [disabled]="apFinalised" matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.restrictedCredit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Restricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                      <!--<input matInput type="text" appInputRestriction='decimalOnly' [value]="element.restrictedCredit==''?null:element.restrictedCredit" maxlength="8"
                      [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Restricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                    </mat-form-field>
                  </td>
                  <td class="w130">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input [disabled]="apFinalised" matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.endowmentDebit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Debit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Debit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />

                      <!--<input matInput type="text" appInputRestriction='decimalOnly' [value]="element.endowmentDebit==''?null:element.endowmentDebit" maxlength="8"
                      [ngClass]="element.nature=='Debit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Debit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                    </mat-form-field>
                  </td>
                  <td class="w130">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input [disabled]="apFinalised" matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.endowmentCredit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />

                      <!--<input matInput type="text" appInputRestriction='decimalOnly' [value]="element.endowmentCredit==''?null:element.endowmentCredit" maxlength="8"
                      [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                    </mat-form-field>
                  </td>

                  @if(this.Basicinfodata[0]?.withPrevoiusPeriod){
                  <td class="w130">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input [disabled]="true" matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.openingBalanceDebit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Debit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                      <!--<input matInput type="text" disabled appInputRestriction='decimalOnly' [value]="element.openingBalanceDebit==''?null:element.openingBalanceDebit" maxlength="8"
                      [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                    </mat-form-field>
                  </td>
                  <td class="w130">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input [disabled]="true" matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.openingBalanceCredit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                      <!--<input matInput type="text" disabled maxlength="8" appInputRestriction='decimalOnly' [value]="element.openingBalanceCredit==''?null:element.openingBalanceCredit"
                      [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                    </mat-form-field>
                  </td>
                  }
                  }

                  }
                </tr>

              </ng-container>
            </ng-container>

            <ng-container *ngIf="noRecordsfound">
              <tr>
                <td colspan="10" style="text-align:center">
                  <b>No Records Found</b>
                </td>

              </tr>
            </ng-container>
          </tbody>
          <tfoot style="z-index: 999; bottom: -1px; position: sticky; background: #edf3f5;">
            <tr class="footer-row">
              <td></td>
              <td class="f-w-600 f-s-14">Total</td>
              <td class="f-w-600 f-s-14 text-right">&pound;{{TotalUnrestrictedDebit | number:'1.2-2'}}</td>
              <td class="f-w-600 f-s-14 text-right">&pound;{{TotalUnrestrictedCredit | number:'1.2-2'}}</td>
              <td class="f-w-600 f-s-14 text-right">&pound;{{TotalRestrictedDebit | number:'1.2-2'}}</td>
              <td class="f-w-600 f-s-14 text-right">&pound;{{TotalRestrictedCredit | number:'1.2-2'}}</td>
              <td class="f-w-600 f-s-14 text-right">&pound;{{TotalEndowmentDebit | number:'1.2-2'}}</td>
              <td class="f-w-600 f-s-14 text-right">&pound;{{TotalEndowmentCredit | number:'1.2-2'}}</td>
              @if(this.Basicinfodata[0]?.withPrevoiusPeriod){
              <td class="f-w-600 f-s-14 text-right">&pound;{{TotalPY_Debit | number:'1.2-2'}}</td>
              <td class="f-w-600 f-s-14 text-right">&pound;{{TotalPY_Credit | number:'1.2-2'}}</td>
              }
            </tr>
          </tfoot>
        </table>
        }
        @else{<!-- for grid of With out fund  tracking-->
        <table class="data-table">
          <!-- Header row for column names -->
          <thead style="position: sticky; top: 0px; z-index: 999;">

            <tr>
              <th class="f-s-14 f-w-500" colspan="2"> Particulars/Description </th>
              <th class="f-s-14 f-w-500 text-center" colspan="2"></th>
              <th class="f-s-14 f-w-500 text-center" colspan="2"> Current Period</th>
              <th class="f-s-14 f-w-500 text-center" colspan="4" *ngIf="this.Basicinfodata[0]?.withPrevoiusPeriod"> Previous Period </th>
            </tr>
            <tr>
              <th class="expand-column" colspan="2" style="width:14%;">
                <div class="" style="border-radius: 4px 0px 0px 0px;">
                  <mat-form-field appearance="outline" class="hide-hint bg-white" style="border-radius: 10px; width:100%">
                    <input matInput type="search" placeholder="Search" appInputRestriction='Trim' style="direction: ltr; text-align: left;" [(ngModel)]="searchTerm" (input)="searchAccounts($event.target.value)" />
                    <mat-icon matSuffix>
                      <i-tabler name="search" class="icon-20 m-0" style="line-height: 15px !important"></i-tabler>
                    </mat-icon>
                  </mat-form-field>
                </div>
              </th>
              <th colspan="2" *ngFor="let column of displayedColumnsUpdatedTrial" class="f-s-14 f-w-500 text-right p-r-14"> {{ getColumnDisplayName(column) }} </th>
            </tr>
          </thead>
          <!-- Body with grouped data -->
          <tbody style="border: 1px solid #ebebeb; max-height: 550px; overflow-y: auto;">
            <ng-container *ngFor="let group of groupedData; let i = index">
              <!-- Header row (expandable) -->
              @if(group.showHeaer==true){
              <tr class="header-row" (click)="toggleGroup(i)">
                <td class="expand-column">
                  <mat-icon class="f-s-18 f-w-500 p-t-4">{{ group.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                </td>
                <td colspan="10" class="header-cell f-s-14 f-w-600">{{ group.header.text }}</td>
              </tr>
              }
              <!-- Data rows (collapsible) -->
              <ng-container *ngIf="group.expanded">
                <tr *ngFor="let element of group.data" class="data-row">
                  @if(element.display==true){
                  @if(element.dataType=='Subheader'){
                  <td class="expand-column" style="background: #e7f3f2;"></td>
                  <td colspan="10" style="width: 550px !important; text-wrap: auto; background: #e7f3f2;" class="f-w-500 f-s-14">{{ element.accountName }}</td>
                  }
                  @if(element.dataType=='Subheader1'){
                  <td class="expand-column" style="background: #efefef;"></td>
                  <td colspan="10" style="width: 550px !important; background: #efefef; text-wrap: auto; " class="f-w-500 f-s-14 p-l-14">{{ element.accountName }}</td>
                  }
                  @else if(element.dataType=='Data'){
                  <td class="expand-column"></td>
                  <td style="width: 550px !important; text-wrap: auto;">{{ element.accountName }}</td>

                  <td colspan="2">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <!--<input matInput type="text" appInputRestriction='acceptOnlyNumbers' [value]="element.currentPeriodDebit==''?null:element.currentPeriodDebit" maxlength="8"
                      [ngClass]="element.nature=='Debit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation($event,element.headersID,element.trailBalanceID,'Debit',element.accountCode,element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                      <input [disabled]="apFinalised" matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.currentPeriodDebit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Debit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation($event,element.headersID,element.trailBalanceID,'Debit',element.accountCode,element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                    </mat-form-field>
                  </td>
                  <td colspan="2">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <!--<input matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.currentPeriodCredit"
                      [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                      (change)="CurrentPeriod_Calculation($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                      <input [disabled]="apFinalised" matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.currentPeriodCredit" (input)="MarkDirty()"
                             [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                             (change)="CurrentPeriod_Calculation($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                    </mat-form-field>
                  </td>

                  @if(this.Basicinfodata[0]?.withPrevoiusPeriod){
                  <td>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input [disabled]="true" matInput type="text" appInputRestriction='acceptOnlyNumbers' [value]="element.openingBalanceDebit==''?null:element.openingBalanceDebit" maxlength="8" (input)="MarkDirty()"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                    </mat-form-field>
                  </td>
                  <td colspan="3">
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                      <input [disabled]="true" matInput type="text" maxlength="8" appInputRestriction='acceptOnlyNumbers' [value]="element.openingBalanceCredit==''?null:element.openingBalanceCredit" (input)="MarkDirty()"
                             (change)="CurrentPeriod_Calculation_FT($event,element.headersID,element.trailBalanceID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                    </mat-form-field>
                  </td>
                  }
                  }
                  }
                </tr>

              </ng-container>
            </ng-container>

            <ng-container *ngIf="noRecordsfound">
              <tr>
                <td colspan="10" style="text-align:center">
                  <b>No records Found</b>
                </td>

              </tr>
            </ng-container>
          </tbody>
          <tfoot style="z-index: 999; bottom: -1px; position: sticky; background: #edf3f5;">
            <tr class="footer-row">
              <td></td>
              <td class="f-w-600 f-s-14">Total</td>

              <td class="f-w-600 f-s-14 text-right" colspan="2">&pound;{{TotalcurrentPeriodDebit | number:'1.2-2'}}</td>
              <td class="f-w-600 f-s-14 text-right" colspan="2">&pound;{{TotalcurrentPeriodCredit | number:'1.2-2'}}</td>
              @if(this.Basicinfodata[0]?.withPrevoiusPeriod){
              <td class="f-w-600 f-s-14 text-right" colspan="2">&pound;{{TotalPY_Debit | number:'1.2-2'}}</td>
              <td class="f-w-600 f-s-14 text-right" colspan="3" style="width: 16%;">&pound;{{TotalPY_Credit | number:'1.2-2'}}</td>
              }
            </tr>
          </tfoot>
        </table>
        }
      </div>


      <div class="row p-16" style="">

        <div class="col-md-4 col-4">
          <button mat-flat-button color="primary" class="bg-warning text-end" (click)="BackToBasicInfo()">
            <i-tabler class="icon-16 m-r-4 m-t-2 text-black" name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back </span>
            <!--<div class="d-flex text-black">
              <i-tabler class="icon-16 m-r-4 m-t-2 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
            </div>-->
          </button>
        </div>
        <div class="col-md-8 col-8" align="right">
          @if(saveType == 'SaveAndNext'){
          <button mat-flat-button color="primary" class="bg-success rounded-5" [disabled]="DisableSavebtn" (click)="SaveTrailbalance('Update')">
            <div class="d-flex text-white">
              <!--<i-tabler class="icon-16 m-r-4 m-t-2" name="arrow-right"></i-tabler><span class="f-s-14"> Update &amp; Next</span>-->
              <i-tabler class="icon-16 m-r-4 m-t-2" name="arrow-right"></i-tabler><span class="f-s-14">  Next</span>
            </div>
          </button>
          }
          @else{
          <button mat-flat-button class="bgwhite border-light b-1 text-end m-r-10" (click)="SaveasDraft()">
            <div class="d-flex text-black">
              <i-tabler class="icon-20 m-r-4 m-t-2" name="device-floppy"></i-tabler><span class="f-s-14 hidemenutext"> Save as Draft</span>
            </div>
          </button>
          <button mat-flat-button color="primary" class="bg-success rounded-5" [disabled]="DisableSavebtn" (click)="SaveTrailbalance('Save')">
            <div class="d-flex text-white">
              <!--<i-tabler class="icon-16 m-r-4 m-t-2" name="arrow-right"></i-tabler><span class="f-s-14 hidemenutext"> Save &amp; Next</span>-->
              <i-tabler class="icon-16 m-r-4 m-t-2" name="arrow-right"></i-tabler><span class="f-s-14 hidemenutext">  Next</span>
            </div>
          </button>
          }
        </div>
      </div>

    </mat-card-content>
  </mat-card>

</div>

<ng-template #importTrial>
  <mat-card style="height:56%; margin-bottom: 0px !important;" class="shadow-none" id="import">
    <mat-card-content class="p-10 p-x-16">

      <div class="col-12 b-b-1 p-b-10">
        <div class="row">
          <div class="col-sm-10 col-md-8 col-lg-6 align-content-center">
            <mat-card-title class="mat-mdc-card-title ">
              <h4 class="f-s-18 f-w-700">Import Trial Balance</h4>
            </mat-card-title>
          </div>
          <div class="col-sm-2 col-md-4 col-lg-6 text-right">
            <div class="d-flex justify-content-end">
              <!--<button mat-icon-button class="" (click)="CloseImport(importTrial)">
                <i-tabler name="X" class="icon-20 m-r-2"></i-tabler>
              </button>-->
              <button class="text-center btn-close-dialog" (click)="CloseImport(importTrial)">
                <i-tabler class="icon-16" name="x"></i-tabler>
              </button>
            </div>
          </div>
        </div>
      </div>

      <mat-stepper #stepper class="m-t-20 upload-file-stepper">
        <mat-step [stepControl]="firstFormGroup">
          <form class="m-t-24" [formGroup]="firstFormGroup">
            <ng-template matStepLabel>
              <mat-card-title class="mat-mdc-card-title center">
                <h4 class="f-s-14 f-w-600">Upload File</h4>
              </mat-card-title>
            </ng-template>

            <mat-card class="b-1 shadow-none">
              <mat-card-content class="p-0">
                <div class="p-10 p-y-20 brandbglight" style="border-radius: 10px;">
                  <mat-card-title class="mat-mdc-card-title">
                    <h4 class="f-s-14 f-w-400">Select a CSV or Excel file from the Desktop to upload</h4>
                  </mat-card-title>
                </div>
              </mat-card-content>
            </mat-card>



            <div class="container-fluid">
              <div class="cust-card rounded">
                <div class="p-0">
                  <div class="d-flex justify-content-between flex-wrap align-items-center" *ngIf="selectedFileName=='No File Chosen'">
                    <mat-card-subtitle class="m-b-0 p-b-0">Upload File</mat-card-subtitle>
                    <button mat-button class="m-t-0" (click)="DownLoadSamplefile()">
                      Download a Sample File  <i-tabler class="icon-18 m-l-10" name="file-download"></i-tabler>
                    </button>
                  </div>
                  <div class="brandborder p-24 rounded m-t-0 align-items-center text-center"
                       *ngIf="selectedFileName === 'No File Chosen'"
                       (dragover)="onDragOver($event)"
                       (dragleave)="onDragLeave($event)"
                       (drop)="onFileDrop($event)"
                       [ngClass]="{ 'drag-active': isDragging }">

                    <div class=" m-t-0 align-items-center text-center" *ngIf="selectedFileName=='No File Chosen'">
                      <i-tabler name="cloud-upload" class="icon-40 m-t-16"></i-tabler>
                      <h4 class="m-t-10 f-s-14 f-w-600">{{selectedFileName}}</h4>
                      <h3 class="f-s-14 f-w-500 brand m-t-10">Size: {{selectedFileSize }} KB | Maximum File Size: 5 MB</h3>
                      <!--<label class="upload-file-name mb-0 mt-1 d-block" style="padding: 0; text-overflow: ellipsis; overflow: hidden; white-space: nowrap;" id="FileName" *ngIf="selectedFile">
                        {{selectedFile.name}}  Size : {{selectedFile.size/1024}}
                      </label>-->
                      <div>
                        <div class="custom-file">
                          <label for="formFile" class="custom-file-upload">
                            <i-tabler class="icon-18 m-r-10" name="Upload"></i-tabler> Upload File
                          </label>
                          <input type="file" #fileUpload class="custom-file-input form-control" accept=".csv,.xlsx,.xls" (click)="fileUpload.value=null"
                                 (change)="readFileAndGetJson($event)" style="height:56px;" id="formFile">
                          <!--<label class="upload-file-name mb-0 mt-1" id="FileName">{{selectedFile.name}}</label>-->

                        </div>







                        <!--<label class="pt-2 ">Size: {{comapreSize +' '}}KB | Maximum File Size: 5 MB</label><br />-->
                        <!--         <label class="float-start"><a href="../../../../assets/SampleExcells/TrialBalance-With Fund Track.xlsx" class="" download="Sample.xlsx"> Download a sample file <i class="fa fa-download fa-icon-size"></i></a></label>-->
                        <!-- <button mat-button class="m-t-10 b-0" (click)="clearFile()" *ngIf="selectedFileName!=null && selectedFileName!='No File Chosen'">Remove</button>-->

                      </div>
                    </div>
                  </div>

                  <div class="container m-t-24 filename"
                       *ngIf="selectedFileName !== null && selectedFileName !== 'No File Chosen'"
                       (dragover)="onDragOver($event)"
                       (dragleave)="onDragLeave($event)"
                       (drop)="onFileDrop($event)"
                       [ngClass]="{ 'drag-active': isDragging }">
                    <div class="container m-t-24 filename" *ngIf="selectedFileName!=null && selectedFileName!='No File Chosen'">
                      <div class="d-flex justify-content-between align-items-center wrap-mob">
                        <mat-card-subtitle class="m-b-0 p-b-0">Upload File</mat-card-subtitle>
                        <button mat-button class="m-t-0" (click)="DownLoadSamplefile()">
                          Download a Sample File  <i-tabler class="icon-18 m-l-10" name="file-download"></i-tabler>
                        </button>
                      </div>
                      <div class="d-flex align-items-baseline justify-content-between m-t-16">
                        <div class="w-100 d-flex align-items-baseline gap-0 hidespace">
                          <mat-form-field appearance="outline" style="width: 80%;" [ngClass]="{ 'customvalid':(maximumSizeExceeds || !selectedFileValid) }">
                            <input type="text" matInput readonly="" class="form-control" style="width: 90%;" value={{selectedFile.name}}>
                          </mat-form-field>
                          <label for="formFile" class="custom-file-upload m-l-0 f-s-14">
                            Browse
                          </label>
                          <input type="file" #fileUpload class="custom-file-input form-control" accept=".csv,.xlsx,.xls" (click)="fileUpload.value=null"
                                 (change)="readFileAndGetJson($event)" style="height:56px;" id="formFile">

                          <button mat-button class="btn btn-none" (click)="clearFile()"><i-tabler class="icon-16 text-danger" name="x"></i-tabler></button>
                        </div>
                      </div>
                      <!--<p class="text-left text-danger f-s-12 p-s-10 f-w-400 m-0 m-t--10">
                        File format not supported
                      </p>-->
                      <!--<label class="custom-file-label short-file-name form-control" style="font-size:12px;" #labelImport for="formFile" [ngClass]="{ 'is-invalid':(!selectedFileValid)}">Invalid File Format</label>-->
                      <!--<label class="custom-file-label short-file-name form-control" style="font-size:12px;" #labelImport for="formFile"  *ngIf="!selectedFileValid">Invalid File Format</label>-->
                      <div>
                        <mat-error class="m-l-0" *ngIf="!selectedFileValid">
                          File Format not Supported
                        </mat-error>
                        <mat-error class="m-l-0" *ngIf="maximumSizeExceeds">
                          Maximum file size exceeded
                        </mat-error>
                        <p class="text-left f-s-12 p-s-10 f-w-400 m-0 m-t-0">
                          <span>Size: {{selectedFileSize }} KB | Maximum File Size: 5 MB</span>
                        </p>
                      </div>
                    </div>

                  </div>


                </div>
              </div>
              <div class="text-right m-t-20">
                <button mat-flat-button matStepperNext [disabled]="selectedFileName =='No File Chosen' || !selectedFileValid || maximumSizeExceeds">Next</button>
                <!--<button mat-flat-button matStepperNext >Next</button>-->
              </div>
            </div>
          </form>
        </mat-step>
        <mat-step [stepControl]="secondFormGroup">
          <form class="m-t-24" [formGroup]="secondFormGroup">
            <ng-template matStepLabel>
              <mat-card-title class="mat-mdc-card-title center" [ngClass]="(selectedFileName =='No File Chosen' || !selectedFileValid || maximumSizeExceeds ? 'stepperdisabled' : '')">
                <h4 class="f-s-14 f-w-600">Data Mapping</h4>
              </mat-card-title>
            </ng-template>

            <mat-card class="b-1 shadow-none">
              <mat-card-content class="p-0">
                <div class="p-10 p-y-20 brandbglight" style="border-radius: 10px;">
                  <mat-card-title class="mat-mdc-card-title">
                    <h4 class="f-s-14 f-w-400">Your Selected File:  {{selectedFileName}}</h4>
                  </mat-card-title>
                </div>
              </mat-card-content>
            </mat-card>

            <div class="container-fluid">
              <div class="cust-card rounded b-1">

                <div class="p-0">

                  <!--<div class="table-responsive rounded-3 mx-2 my-2" style="border: 1px solid #ebebeb; height: 550px;">-->
                  <div class="table-responsive rounded-3 mx-2 my-2" style="border: 1px solid #ebebeb; height: 430px;">

                    <table class="data-table">
                      <!-- Header row for column names -->
                      <thead>
                        <tr>
                          <th class="expand-column"></th>
                          <th class="f-s-14 f-w-500 text-center"> Allowed Columns </th>
                          <th class="f-s-14 f-w-500 text-center"> CSV Columns </th>
                        </tr>
                      </thead>
                      <!-- Body with grouped data -->
                      <tbody style="max-height: 550px; overflow-y: auto;">
                        <ng-container *ngFor="let group of ExcellDropDowngroupedData; let i = index">
                          <!-- Header row (expandable) -->
                          <tr class="header-row" (click)="ExcellDropDowntoggleGroup(i)">
                            <td class="expand-column">
                              <mat-icon class="f-s-18 f-w-500" style="padding-top:3px !important;">{{ group.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                            </td>
                            <td colspan="3" class="header-cell f-s-14 f-w-600">{{ group.header.text }}</td>
                          </tr>
                          <!-- Data rows (collapsible) -->
                          <ng-container *ngIf="group.expanded">
                            <tr *ngFor="let element of group.data" class="data-row">
                              @if(element.dataType=='Subheader'){
                              <td class="expand-column"></td>
                              <td colspan="10" style="width: 550px !important; text-wrap: auto;" class="f-w-500 f-s-14">{{ element.accountName }}</td>
                              }
                              @if(element.dataType=='Subheader1'){
                              <td class="expand-column"></td>
                              <td colspan="10" style="width: 550px !important; text-wrap: auto;" class="f-w-500 f-s-14 p-l-14">{{ element.accountName }}</td>
                              }
                              @else if(element.dataType=='Data'){
                              <td class="expand-column"></td>
                              <td style="width: 550px !important; text-wrap: auto;">{{ element.accountName }}</td>

                              <td>
                                <div class="d-flex gap-10 align-items-center custom">

                                  <mat-form-field appearance="outline" class="w-100 m-t-8">
                                    <mat-select placeholder="Select a column"
                                                [value]="element.uniqueAccountsID"
                                                (selectionChange)="SetDropExcellDown($event.value,element,i, j)">

                                      <mat-option *ngFor="let Account of ExcellDropDownData;let j=index"
                                                  [value]="Account.uniqueAccountsID">
                                        {{Account.accountName}}
                                      </mat-option>

                                    </mat-select>
                                  </mat-form-field>



                                  <button mat-icon-button (click)="ClearDropDown(element)" aria-label="Clear selection">
                                    <mat-icon>clear</mat-icon>
                                  </button>

                                </div>
                              </td>
                              }
                            </tr>
                            <!--<tr *ngFor="let element of group.data" class="footer-row">
                              <td></td>
                              <td>Total</td>
                              <td>0.00</td>
                              <td>0.00</td>
                            </tr>-->
                          </ng-container>
                        </ng-container>
                      </tbody>
                    </table>


                    <!--<table mat-table [dataSource]="ExcelTrailBalanceTemplate" class="w-100 d-none">
                      <ng-container matColumnDef="Allowed Columns">
                        <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">Allowed Columns</th>
                        <td mat-cell *matCellDef="let row" class="p-l-30" [ngClass]="row.dataType=='Subheader' || row.dataType=='Subheader1' ? 'f-w-600' : '' " style="width: 60%;">{{ row.accountName }}</td>-->
                    <!--<td mat-footer-cell *matFooterCellDef class="example-first-footer-row-1 f-w-600 f-s-16">Totals</td>-->
                    <!--</ng-container>

                    <ng-container matColumnDef="CSV Columns">
                      <th mat-header-cell *matHeaderCellDef class="f-w-600 f-s-14">CSV Columns</th>
                      <td mat-cell *matCellDef="let row">
                        <div class="d-flex gap-10 align-items-center custom" [ngClass]="row.dataType=='Subheader' || row.dataType=='Subheader1' ? 'd-none' : '' ">
                          <mat-form-field appearance="outline" class="w-100 m-t-8">

                            <mat-select placeholder="Select a column" (selectionChange)='SetDropExcellDown($event,$event.source.value,row.accountName,row.headersName)'
                                        [value]="row.ExceldropDownValue">
                              <mat-option *ngFor="let Account of ExcellDropDownData">
                                {{ Account.accountName }}drop don
                              </mat-option>

                            </mat-select>-->
                    <!--ok-->      <!--dropDownValue,ExceldropDownValue are  the combimation of HeadeName and Accountname {'HeadeName-Accountname'}-->
                    <!--</mat-form-field>

                            <button mat-icon-button (click)="ClearDropDown(row)" aria-label="Clear selection">
                              <mat-icon>clear</mat-icon>
                            </button>

                          </div>
                        </td>

                      </ng-container>

                      <ng-container matColumnDef="heading">
                        <td mat-cell *matCellDef="let row" colspan="3" class="f-w-600 f-s-14 expence-row" style="background: #e4eff4;">
                          {{row.headersName}}
                        </td>
                      </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns3; sticky: true" class="example-first-header-row"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns3;"></tr>
                      <tr mat-row *matRowDef="let row; columns: ['heading']; when: isHeadimportRow"></tr>

                    </table>-->
                  </div>

                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between m-t-20">
                <!--<button mat-flat-button class="bgwhite m-r-10" matStepperPrevious>
                  Back
                </button>-->

                <button mat-flat-button color="primary" class="bg-warning text-end" matStepperPrevious>
                  <div class="d-flex text-black">
                    <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
                  </div>
                </button>
                <button mat-flat-button matStepperNext (click)="AfterDataMaping()">Next</button>
              </div>
            </div>

          </form>
        </mat-step>
        <mat-step>
          <ng-template matStepLabel>
            <!--<div class="cust-tab-pill rounded p-10">
              <i-tabler name="eye" class="icon-18"></i-tabler>
            </div>-->
            <mat-card-title class="mat-mdc-card-title center" (click)="onexpclick1()" [ngClass]="selectedFileName =='No File Chosen' || !selectedFileValid || maximumSizeExceeds ? 'stepperdisabled' : ''">
              <h4 class="f-s-14 f-w-600">Preview</h4>
            </mat-card-title>
          </ng-template>

          <div class="container-fluid m-t-16 p-b-24" *ngIf="!isFundTracking" style="overflow-y:auto;overflow-x:hidden;">

            <mat-accordion class="m-t-14">

              <mat-expansion-panel (opened)="panelOpenState = true"
                                   (closed)="panelOpenState = false" [expanded]="openImport" (click)="onexpclick1()" class="cust-preview-panel m-t-10 f-s-14">
                <mat-expansion-panel-header class="f-s-14" style="background: #e3eff4;" (click)="onexpclick()">
                  <mat-panel-title>
                    Trial Balance is ready to be imported
                  </mat-panel-title>

                </mat-expansion-panel-header>
                <mat-panel-description class="d-block p-0 m-0">
                  <div class="cust-card rounded b-1">
                    <div class="p-x-10 m-t-10">
                      <div class="row align-items-center">
                        <div class="col-lg-3">
                          <div class="m-l-10 d-flex align-items-center">
                            <div *ngIf="ExcellTotalDebits==ExcellTotalCredits">
                              <div style="padding: 10px 12px; border-radius: 20%;" class="bg-light-success">
                                <i-tabler name="circle-check" class="icon-28 text-success"></i-tabler>
                              </div>
                            </div>
                            <div *ngIf="ExcellTotalDebits!=ExcellTotalCredits">
                              <div style="padding: 10px 12px; border-radius: 20%;" class="bg-light-error">
                                <i-tabler name="alert-circle" class="icon-28 text-danger"></i-tabler>
                              </div>
                            </div>
                            <div class="m-l-10">
                              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-r-10">
                                Balance Status
                              </h4>
                              <div>
                                <h5 *ngIf="ExcellTotalDebits==ExcellTotalCredits" class="text-success f-s-14 f-w-600">Trial Balance is balanced  </h5>
                                <h5 *ngIf="ExcellTotalDebits!=ExcellTotalCredits" class="text-danger f-s-14 f-w-600">Trial Balance is unbalanced </h5>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-9 text-right">
                          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
                            <mat-card class="m-0" style="margin-bottom: 0px !important;">
                              <mat-card-content class="card-diff brandbglight p-16 p-x-32" style="border-radius: 10px; background: #107e760a !important;">
                                <h5 class="primary-color-dark f-s-14 f-w-600">Difference: </h5>

                                <p *ngIf="ExcelTotalcurrentPeriodCredit!=ExcelTotalcurrentPeriodDebit" class="text-danger brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(ExcelTotalcurrentPeriodCredit,ExcelTotalcurrentPeriodDebit))| number:'1.2-2'}}</p>
                                <p *ngIf="ExcelTotalcurrentPeriodCredit==ExcelTotalcurrentPeriodDebit" class="text-success brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(ExcelTotalcurrentPeriodCredit,ExcelTotalcurrentPeriodDebit))| number:'1.2-2'}}</p>
                              </mat-card-content>
                            </mat-card>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--<div class="table-responsive  m-20 m-t-10 shadow-lg" style="height: 420px;">-->
                    <div class="table-responsive  m-20 m-t-10 shadow-lg">

                      <table class="data-table">
                        <!-- Header row for column names -->
                        <thead>
                          <tr>
                            <th class="f-s-14 f-w-500" colspan="2"> Particulars/Description</th>
                            <th class="f-s-14 f-w-500"></th>
                            <th class="f-s-14 f-w-500 text-start"> Current Period </th>
                          </tr>
                          <tr>
                            <th class="expand-column"></th>
                            <th class="expand-column" style="width: 550px !important; text-wrap: auto;"></th>
                            <th *ngFor="let column of displayedExcelColumnsUpdatedTrial" class="f-s-14 f-w-500 text-right" style="width:18%;"> {{ getExcelColumnDisplayName(column) }} </th>
                          </tr>
                        </thead>
                        <!-- Body with grouped data -->
                        <tbody style="max-height: 550px; overflow-y: auto;">
                          <ng-container *ngFor="let group of ExcellTempgroupedData; let i = index">
                            <!-- Header row (expandable) -->
                            <tr class="header-row" (click)="ExcellMaptoggleGroup(i)">
                              <td class="expand-column">
                                <mat-icon class="f-s-18 f-w-500" style="padding-top:3px !important;">{{ group.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                              </td>
                              <td colspan="10" class="header-cell f-s-14 f-w-600">{{ group.header.text }}</td>
                            </tr>
                            <!-- Data rows (collapsible) -->
                            <ng-container *ngIf="group.expanded">
                              <tr *ngFor="let element of group.data" class="data-row">
                                @if(element.dataType=='Subheader'){
                                <td class="expand-column" style="background: #e7f3f2;"></td>
                                <td colspan="10" style="width: 550px !important; text-wrap: auto; background: #e7f3f2;" class="f-w-500 f-s-14">{{ element.accountName }}</td>
                                }
                                @if(element.dataType=='Subheader1'){
                                <td class="expand-column" style="background: #efefef;"></td>
                                <td colspan="10" style="width: 550px !important; background: #efefef; text-wrap: auto; " class="f-w-500 f-s-14 p-l-14">{{ element.accountName }}</td>
                                }
                                @else if(element.dataType=='Data'){
                                <td class="expand-column"></td>
                                <td style="width: 550px !important; text-wrap: auto;">{{ element.accountName }}</td>

                                <td>
                                  <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <!--<input matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.currentPeriodDebit"
                                           [ngClass]="element.nature=='Debit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation($event,element.headersID,element.uniqueAccountsID,'Debit',element.accountCode,element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                                    <input matInput type="text" appTwoDigitDecimalNumber
                                           [(ngModel)]="element.currentPeriodDebit  "
                                           [ngClass]="element.nature=='Debit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation($event,element.headersID,element.uniqueAccountsID,'Debit',element.accountCode,element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                                  </mat-form-field>
                                </td>
                                <td>
                                  <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <!--<input matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.currentPeriodCredit"
                                           [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation($event,element.headersID,element.uniqueAccountsID,'Credit',element.accountCode,element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                                    <input matInput type="text" appTwoDigitDecimalNumber
                                           [(ngModel)]="element.currentPeriodCredit"
                                           [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation($event,element.headersID,element.uniqueAccountsID,'Credit',element.accountCode,element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                                  </mat-form-field>
                                </td>
                                }
                              </tr>
                            </ng-container>
                          </ng-container>

                        </tbody>
                        <tfoot style="z-index: 999; bottom: -1px; position: sticky; background: #e5e5e5;">
                          <tr class="footer-row">
                            <td></td>
                            <td class="f-w-600 f-s-14">Total</td>

                            <td class="f-w-600 f-s-14 text-right">&pound;{{ExcelTotalcurrentPeriodDebit | number:'1.2-2'}}</td>
                            <td class="f-w-600 f-s-14 text-right">&pound;{{ExcelTotalcurrentPeriodCredit | number:'1.2-2'}}</td>

                          </tr>
                        </tfoot>
                      </table>

                    </div>
                  </div>
                </mat-panel-description>
              </mat-expansion-panel>
            </mat-accordion>

            <mat-accordion class="m-t-14" *ngIf="+errorsCount>0">

              <mat-expansion-panel (opened)="openImport = false" (click)="onexpclick()"
                                   (closed)="panelOpenState = false" [expanded]="OpenErrors" class="cust-preview-panel m-t-10 f-s-14">
                <mat-expansion-panel-header class="f-s-14" style="background: #e3eff4;">
                  <mat-panel-title>
                    Trial balance is not mapped due to errors&nbsp;<span class="ms-1"> ({{errorsCount}})</span>
                  </mat-panel-title>

                </mat-expansion-panel-header>
                <mat-panel-description class="d-block p-0 m-0">
                  <div class="table-responsive shadow-lg m-t-15" style="height:400px">
                    <table class="w-100">
                      <thead style="background: #cee3ea">
                        <tr>
                          <td class=" text-left">Field Name</td>
                          <td class="text-center">Field Value</td>

                          <td class="text-center">Reason</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let error of errorLogs">
                          <td class="text-left" style=" word-break: break-all; white-space: normal;">{{error.filedName+' - '+ error.columnName}}</td>
                          <td class="text-center" style=" word-break: break-all; white-space: normal;">{{error.fieldValue}}</td>

                          <!--<td class="text-center">{{error.columnName}}</td>-->
                          <td class="text-center " style=" word-break: break-all; white-space: normal;">{{error.reason}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </mat-panel-description>
              </mat-expansion-panel>
            </mat-accordion>


            <div class="d-flex justify-content-between m-t-16">
              <button mat-flat-button
                      class="bgwhite m-r-10"
                      matStepperPrevious>
                Back
              </button>
              <button mat-flat-button [disabled]="(getAbsoluteDifference(ExcelTotalcurrentPeriodDebit,ExcelTotalcurrentPeriodCredit))!=0||(errorsCount > 0)" (click)="stepper.reset();FinishExcellImport()">Import</button>
            </div>
          </div>
          <div class="container-fluid  bg-white m-x-auto p-0" *ngIf="isFundTracking">

            <mat-accordion class="m-t-14">

              <mat-expansion-panel (opened)="panelOpenState = true" [expanded]="openImport" (click)="onexpclick1()"
                                   (closed)="panelOpenState = false" class="cust-preview-panel m-t-10 f-s-14">
                <mat-expansion-panel-header class="f-s-14" style="background: #e3eff4;">
                  <mat-panel-title>
                    Trial Balance is ready to be imported
                  </mat-panel-title>

                </mat-expansion-panel-header>
                <mat-panel-description class="d-block p-0 m-0">
                  <div class="cust-card rounded b-1">
                    <!--/* New Trail Balance Design*/-->
                    <div class="p-x-10 m-t-10">
                      <div class="row align-items-center">
                        <div class="col-lg-3">
                          <div class="m-l-10 d-flex align-items-center">
                            <div *ngIf="( (getAbsoluteDifference(ExcelTotalUnrestrictedCredit,ExcelTotalUnrestrictedDebit)==0) && (getAbsoluteDifference(ExcelTotalRestrictedDebit,ExcelTotalRestrictedCredit)==0) && (getAbsoluteDifference(ExcelTotalEndowmentDebit,ExcelTotalEndowmentCredit)==0) )">
                              <div style="padding: 10px 12px; border-radius: 20%;" class="bg-light-success">
                                <i-tabler name="circle-check" class="icon-28 text-success"></i-tabler>
                              </div>
                            </div>
                            <div *ngIf="( (getAbsoluteDifference(ExcelTotalUnrestrictedCredit,ExcelTotalUnrestrictedDebit)!=0) || (getAbsoluteDifference(ExcelTotalRestrictedDebit,ExcelTotalRestrictedCredit)!=0) || (getAbsoluteDifference(ExcelTotalEndowmentDebit,ExcelTotalEndowmentCredit)!=0) )">
                              <div style="padding: 10px 12px; border-radius: 20%;" class="bg-light-error">
                                <i-tabler name="alert-circle" class="icon-28 text-danger"></i-tabler>
                              </div>
                            </div>
                            <div class="m-l-10">
                              <h4 class="headingmain f-s-16 f-w-600 m-t-0 m-r-10">
                                Balance Status
                              </h4>
                              <div>
                                <h5 *ngIf="( (getAbsoluteDifference(ExcelTotalUnrestrictedCredit,ExcelTotalUnrestrictedDebit)==0) && (getAbsoluteDifference(ExcelTotalRestrictedDebit,ExcelTotalRestrictedCredit)==0) && (getAbsoluteDifference(ExcelTotalEndowmentDebit,ExcelTotalEndowmentCredit)==0) )" class="text-success f-s-14 f-w-600">Trial Balance is balanced </h5>
                                <h5 *ngIf="( (getAbsoluteDifference(ExcelTotalUnrestrictedCredit,ExcelTotalUnrestrictedDebit)!=0) || (getAbsoluteDifference(ExcelTotalRestrictedDebit,ExcelTotalRestrictedCredit)!=0) || (getAbsoluteDifference(ExcelTotalEndowmentDebit,ExcelTotalEndowmentCredit)!=0) )" class="text-danger f-s-14 f-w-600">Trial Balance is unbalanced </h5>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="col-lg-9 text-right">
                          <div class="d-flex gap-10 justify-content-end custom-cards-trial">
                            <mat-card class="m-0" style="margin-bottom: 0px !important;">
                              <mat-card-content class="card-diff brandbglight p-16" style="border-radius: 10px; background: #107e760a !important;">
                                <h5 class="primary-color-dark f-s-14 f-w-600">Unrestricted Difference:</h5>
                                <p *ngIf="ExcelTotalUnrestrictedCredit!=ExcelTotalUnrestrictedDebit" class="text-danger brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(ExcelTotalUnrestrictedCredit,ExcelTotalUnrestrictedDebit))| number:'1.2-2'}}</p>
                                <p *ngIf="ExcelTotalUnrestrictedCredit==ExcelTotalUnrestrictedDebit" class="text-success brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(ExcelTotalUnrestrictedCredit,ExcelTotalUnrestrictedDebit))| number:'1.2-2'}}</p>
                              </mat-card-content>
                            </mat-card>
                            <mat-card class="m-0" style="margin-bottom: 0px !important;">
                              <mat-card-content class="card-diff brandbglight p-16" style="border-radius: 10px; background: #107e760a !important;">
                                <h5 class="primary-color-dark f-s-14 f-w-600">Restricted Difference: </h5>
                                <p *ngIf="ExcelTotalRestrictedDebit!=ExcelTotalRestrictedCredit" class="text-danger brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(ExcelTotalRestrictedDebit,ExcelTotalRestrictedCredit))| number:'1.2-2'}}</p>
                                <p *ngIf="ExcelTotalRestrictedDebit==ExcelTotalRestrictedCredit" class="text-success brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(ExcelTotalRestrictedDebit,ExcelTotalRestrictedCredit))| number:'1.2-2'}}</p>
                              </mat-card-content>
                            </mat-card>
                            <mat-card class="m-0" style="margin-bottom: 0px !important;">
                              <mat-card-content class="card-diff brandbglight p-16" style="border-radius: 10px; background: #107e760a !important;">
                                <h5 class="primary-color-dark f-s-14 f-w-600">Endowment Difference: </h5>
                                <p *ngIf="ExcelTotalEndowmentDebit!=ExcelTotalEndowmentCredit" class="text-danger brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(ExcelTotalEndowmentDebit,ExcelTotalEndowmentCredit))| number:'1.2-2'}}</p>
                                <p *ngIf="ExcelTotalEndowmentDebit==ExcelTotalEndowmentCredit" class="text-success brandtext f-w-600 f-s-18 text-center m-t-0"> &pound;{{(getAbsoluteDifference(ExcelTotalEndowmentDebit,ExcelTotalEndowmentCredit))| number:'1.2-2'}}</p>
                              </mat-card-content>
                            </mat-card>
                          </div>
                        </div>
                      </div>
                    </div>
                    @if(this.isFundTracking){<!-- for grid of With fund tracking-->
                    <!--<div class="table-responsive m-20 m-t-10 shadow-lg" style="height:380px">-->
                    <div class="table-responsive m-20 m-t-10 shadow-lg">
                      <table class="data-table">
                        <!-- Header row for column names -->
                        <thead>
                          <tr>
                            <th class="f-s-14 f-w-500" colspan="2"> Particulars/Description</th>
                            <th class="f-s-14 f-w-500 text-center" colspan="6"> Current Period </th>
                          </tr>
                          <tr>
                            <th class="expand-column"></th>
                            <th class="expand-column"></th>
                            <th *ngFor="let column of displayedExcelColumnsUpdatedTrial" class="f-s-14 f-w-500 text-right" style="width: 10%; padding: 10px; white-space: nowrap;"> {{ getExcelColumnDisplayName(column) }}  </th>
                          </tr>
                        </thead>
                        <!-- Body with grouped data -->
                        <tbody>
                          <ng-container *ngFor="let group of ExcellTempgroupedData; let i = index">
                            <!-- Header row (expandable) -->
                            <tr class="header-row" (click)="ExcellMaptoggleGroup(i)">
                              <td class="expand-column">
                                <mat-icon class="f-s-18 f-w-500" style="padding-top:3px !important;">{{ group.expanded ? 'keyboard_arrow_down' : 'keyboard_arrow_right' }}</mat-icon>
                              </td>
                              <td colspan="10" class="header-cell f-s-14 f-w-600">{{ group.header.text }}</td>
                            </tr>

                            <!-- Data rows (collapsible) -->
                            <ng-container *ngIf="group.expanded">
                              <tr *ngFor="let element of group.data" class="data-row">
                                @if(element.dataType=='Subheader'){
                                <td class="expand-column" style="background: #e7f3f2;"></td>
                                <td colspan="10" style="width: 450px !important; text-wrap: auto; background: #e7f3f2;" class="f-w-500 f-s-14">{{ element.accountName }}</td>
                                }
                                @if(element.dataType=='Subheader1'){
                                <td class="expand-column" style="background: #efefef;"></td>
                                <td colspan="10" style="width: 450px !important; background: #efefef; text-wrap: auto;" class="f-w-500 f-s-14 p-l-14">{{ element.accountName }}</td>
                                }
                                @else if(element.dataType=='Data'||element.dataType=='footer'){
                                <td class="expand-column"></td>
                                <td style="text-wrap: auto;">{{ element.accountName }}</td>
                                <td class="w130">
                                  <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <!--<input matInput type="text"  appTwoDigitDecimalNumber [(ngModel)]="element.unrestrictedDebit"
                                           [ngClass]="element.nature=='Debit'||element.nature=='debit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Debit',element.accountCode,'Unrestricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                                    <input matInput type="text"
                                           appTwoDigitDecimalNumber
                                           [(ngModel)]="element.unrestrictedDebit"
                                           [ngClass]="element.nature=='Debit'||element.nature=='debit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Debit',element.accountCode,'Unrestricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                                  </mat-form-field>
                                </td>
                                <td class="w130">
                                  <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <!--<input matInput type="text"  appTwoDigitDecimalNumber [(ngModel)]="element.unrestrictedCredit"
                                           [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Credit',element.accountCode,'Unrestricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                                    <input matInput type="text"
                                           appTwoDigitDecimalNumber
                                           [(ngModel)]="element.unrestrictedCredit"
                                           [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Credit',element.accountCode,'Unrestricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                                  </mat-form-field>
                                </td>
                                <td class="w130">
                                  <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <!--<input matInput type="text"  appTwoDigitDecimalNumber [(ngModel)]="element.restrictedDebit"
                                           [ngClass]="element.nature=='Debit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Debit',element.accountCode,'Restricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                                    <input matInput type="text"
                                           appTwoDigitDecimalNumber
                                           [(ngModel)]="element.restrictedDebit"
                                           [ngClass]="element.nature=='Debit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Debit',element.accountCode,'Restricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                                  </mat-form-field>
                                </td>
                                <td class="w130">
                                  <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <!--<input matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.restrictedCredit"
                                           [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Credit',element.accountCode,'Restricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                                    <input matInput type="text" appTwoDigitDecimalNumber
                                           [(ngModel)]="element.restrictedCredit"
                                           [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Credit',element.accountCode,'Restricted',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                                  </mat-form-field>
                                </td>
                                <td class="w130">
                                  <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <!--<input matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.endowmentDebit"
                                           [ngClass]="element.nature=='Debit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Debit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                                    <input matInput type="text" appTwoDigitDecimalNumber
                                           [(ngModel)]="element.endowmentDebit"
                                           [ngClass]="element.nature=='Debit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Debit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                                  </mat-form-field>
                                </td>
                                <td class="w130">
                                  <mat-form-field appearance="outline" class="w-100" color="primary">
                                    <!--<input matInput type="text" appTwoDigitDecimalNumber [(ngModel)]="element.endowmentCredit"
                                           [ngClass]="element.nature=='Credit'||element.nature=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />-->
                                    <input matInput type="text" appTwoDigitDecimalNumber
                                           [(ngModel)]="element.endowmentCredit"
                                           [ngClass]="element.nature=='Credit'||element.nature.toLowerCase()=='nutral' ? 'text-success':'text-danger'"
                                           (change)="ExcelCurrentPeriod_Calculation_FT($event,element.headersID,element.uniqueAccountsID,'Credit',element.accountCode,'Endowment',element.uniqueAccountsID)" placeholder="0.00" class="text-end" />
                                  </mat-form-field>
                                </td>
                                }
                              </tr>

                            </ng-container>
                          </ng-container>

                        </tbody>
                        <tfoot style="z-index: 999; bottom: -1px; position: sticky; background: #e5e5e5;">
                          <tr class="footer-row">
                            <td></td>
                            <td class="f-w-600 f-s-14">Total</td>
                            <td class="f-w-600 f-s-14 text-right">&pound;{{ExcelTotalUnrestrictedDebit | number:'1.2-2'}}</td>
                            <td class="f-w-600 f-s-14 text-right">&pound;{{ExcelTotalUnrestrictedCredit | number:'1.2-2'}}</td>
                            <td class="f-w-600 f-s-14 text-right">&pound;{{ExcelTotalRestrictedDebit | number:'1.2-2'}}</td>
                            <td class="f-w-600 f-s-14 text-right">&pound;{{ExcelTotalRestrictedCredit | number:'1.2-2'}}</td>
                            <td class="f-w-600 f-s-14 text-right">&pound;{{ExcelTotalEndowmentDebit | number:'1.2-2'}}</td>
                            <td class="f-w-600 f-s-14 text-right">&pound;{{ExcelTotalEndowmentCredit | number:'1.2-2'}}</td>

                          </tr>
                        </tfoot>
                      </table>


                    </div>
                    }
                    @else{

                    }

                  </div>
                </mat-panel-description>
              </mat-expansion-panel>
            </mat-accordion>

            <mat-accordion class="m-t-14" *ngIf="+errorsCount>0">

              <mat-expansion-panel (opened)="OpenImport=false" (click)="onexpclick()" [expanded]="OpenErrors"
                                   (closed)="OpenImport = true" class="cust-preview-panel m-t-10 f-s-14">
                <mat-expansion-panel-header class="f-s-14" style="background: #e3eff4;">
                  <mat-panel-title>
                    Trial balance is not mapped due to errors&nbsp;<span class="ms-1"> ({{errorsCount}})</span>
                  </mat-panel-title>

                </mat-expansion-panel-header>
                <mat-panel-description class="d-block p-0 m-0">
                  <div class="table-responsive shadow-lg m-t-15" style="height:400px">
                    <table class="w-100">
                      <thead style="background: #cee3ea">
                        <tr>
                          <td class=" text-left">Field Name</td>
                          <td class="text-center">Field Value</td>

                          <td class="text-center">Reason</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let error of errorLogs">
                          <td class="text-left">{{error.filedName+' - '+ error.columnName}}</td>
                          <td class="text-center">{{error.fieldValue}}</td>

                          <!--<td class="text-center">{{error.columnName}}</td>-->
                          <td class="text-center">{{error.reason}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </mat-panel-description>
              </mat-expansion-panel>
            </mat-accordion>





            <div class="d-flex justify-content-between m-t-16">
              <!--<button mat-flat-button
                      class="bgwhite m-r-10"
                      matStepperPrevious>
                Back
              </button>-->

              <button mat-flat-button color="primary" class="bg-warning text-end" matStepperPrevious>
                <div class="d-flex text-black">
                  <i-tabler class="icon-20 m-r-4 m-t-0 " name="arrow-left"></i-tabler><span class="f-s-12 text-black hidemenutext"> Back</span>
                </div>
              </button>
              <button mat-flat-button [disabled]=" (getAbsoluteDifference(ExcelTotalUnrestrictedCredit,ExcelTotalUnrestrictedDebit))!=0||(getAbsoluteDifference(ExcelTotalRestrictedDebit,ExcelTotalRestrictedCredit))||(getAbsoluteDifference(ExcelTotalEndowmentDebit,ExcelTotalEndowmentCredit))||(errorsCount > 0)" (click)="stepper.reset();FinishExcellImport()">Import</button>
            </div>

          </div>
        </mat-step>
      </mat-stepper>
    </mat-card-content>
  </mat-card>
</ng-template>

<ng-template #modal>
  <mat-card>
    <mat-card-content class="p-20 tbPreview">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>Trial Balance Report</span></b>
          <button class="btn-close-dialog" mat-dialog-close>
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;">
        <div class="col-lg-12" style="height:750px;">
          <ng2-pdfjs-viewer #pdfViewerAutoLoad></ng2-pdfjs-viewer>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>
<div class="spinner-container" *ngIf="ShowSpinner">
  <mat-spinner></mat-spinner>
</div>
<ng-template #emailtemplate>
  <mat-card style="margin-bottom: 0px !important;">
    <mat-card-content class="p-14 p-b-0 tbSendMail">
      <!-- Header Row with Matching Padding -->
      <div class="row mb-3" style="margin-left: 0; margin-right: 0;">
        <div class="col d-flex justify-content-between align-items-center">
          <b><span>Send Mail</span></b>
          <button class="btn-close-dialog" (click)="cenceltemplate()">
            <i-tabler name="X"></i-tabler>
          </button>
        </div>
      </div>

      <!-- PDF Viewer -->
      <div class="row" style="margin-left: 0; margin-right: 0;" [formGroup]="TrialBalanceForm">
        <div class="col-lg-12">
          <div class="p-y-16 b-t-1" style="overflow: hidden;">

            <div class="col-lg-12" style=" padding: 20px; border-radius: 10px;">
              <div class="row align-items-center m-b-8">
                <div class="col-md-10">
                  <div class="d-flex align-items-center">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">From</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" maxlength="40" formControlName="from" value="example@mail.com" [disabled]="true" />
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row align-items-center m-b-8">
                <div class="col-md-10">
                  <div class="d-flex align-items-center">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">To</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" maxlength="100" formControlName="to" value="example@mail.com" />
                      <mat-error *ngIf="TrialBalanceForm.get('to')?.hasError('required')">
                        Email is required
                      </mat-error>
                      <mat-error *ngIf="TrialBalanceForm.get('to')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="d-flex align-items-center mb-0">
                    <mat-checkbox class="example-margin" (change)="SOFAformmailtoCC()" formControlName="ccCheckbox"></mat-checkbox>
                    <label class="f-s-14 f-w-600 m-0 p-0">CC/BCC</label>
                  </div>
                </div>
              </div>
              <div class="row mt-2" *ngIf="ifCCorBCCSOFA">
                <div class="col-md-6">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 88px;">CC</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="example@mail.com" formControlName="cc" maxlength="100" />
                      <mat-error *ngIf="TrialBalanceForm.get('cc')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>

                    </mat-form-field>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 88px;">BCC</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="example@mail.com" formControlName="bcc" maxlength="100" />
                      <mat-error *ngIf="TrialBalanceForm.get('bcc')?.hasError('pattern')">
                        Enter a valid Email
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-12">
                  <div class="d-flex align-items-center m-b-8">
                    <label class="f-s-14 f-w-600 m-0 p-0" style="width: 82px;">Subject</label>
                    <mat-form-field appearance="outline" class="no-subscript bg-white w-100" color="primary">
                      <input matInput class="text-left" value="Welcome to Charity Accounts Software" formControlName="subject" />
                      <mat-error *ngIf="TrialBalanceForm.get('subject')?.hasError('required')">
                        Subject is required
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>

            <mat-card-content class="m-t-14 p-x-0">
              <div class="local-editor NgxEditor__Wrapper" style="height: 300px;">
                <ngx-editor-menu [editor]="editor1" [toolbar]="toolbar" class=""> </ngx-editor-menu>
                <ngx-editor [editor]="editor1" [placeholder]="'Type here...'" formControlName="Body"></ngx-editor>
              </div>
            </mat-card-content>

            <hr class="m-t-24" style="opacity:0.2" />
            <div class="row p-t-16 p-b-0">
              <div class="col-sm-12 col-md-12 text-right">
                <button mat-flat-button type="submit" color="primary" class="bg-success rounded-5 m-r-10" (click)="sendmail()" [disabled]="isBodyEmpty(TrialBalanceForm)">
                  <div class="d-flex">
                    <span class="f-s-14 text-dark"> Send </span>
                  </div>
                </button>
                <button mat-flat-button color="primary" class="bg-white border-light b-1 text-end m-r-10" (click)="cenceltemplate()">
                  <div class="d-flex text-black">
                    <span class="f-s-12 text-black"> Cancel </span>
                  </div>
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</ng-template>

